export default {
  computed: {
    isDev() {
      return process.env.NODE_ENV === "development";
    },
    isHomolog() {
      return process.env.NODE_ENV === "homologation";
    },
  },
  methods: {
    setContent() {
      window.StripoApi.getTemplate((html, css) => {
        this.emitInput({
          htmlContent: html,
          cssStyle: css,
        });
      });
    },
    async initPlugin(template, prefix) {
      const loggedUser = this.$store.state.users.user;

      this.isLoaded = false;

      this.credentials = await this.$api.marketing.email.message.credentials();

      const script = document.createElement("script");
      script.id = "stripoScript";
      script.type = "text/javascript";
      script.src = "https://plugins.stripo.email/static/latest/stripo.js";
      script.onload = () => {
        window.Stripo.init({
          settingsId: "stripoSettingsContainer",
          previewId: "stripoPreviewContainer",
          codeEditorButtonId: "codeEditor",
          undoButtonId: "undoButton",
          redoButtonId: "redoButton",
          locale: "pt",
          html: template.html,
          css: template.css,
          viewOnly: this.viewOnly,
          versionHistory: {
            changeHistoryLinkId: "historyId",
          },
          notifications: {
            info(text, id, params) {
              console.log(text, id, params);
            },
            error(text, id, params) {
              console.log(text, id, params);
            },
            warn(text, id, params) {
              console.log(text, id, params);
            },
            loader(text, id, params) {
              console.log(text, id, params);
            },
            hide(text, id, params) {
              console.log(text, id, params);
            },
            success(text, id, params) {
              console.log(text, id, params);
            },
          },
          apiRequestData: {
            emailId: prefix ? `${prefix}${this.email.id}` : this.email.id,
          },
          userFullName: loggedUser.nome,
          getAuthToken: (callback) => {
            this.request(
              "POST",
              "https://plugins.stripo.email/api/v1/auth",
              JSON.stringify({
                pluginId: this.credentials.clientId,
                secretKey: this.credentials.secret,
              }),
              (data) => {
                const authApi = JSON.parse(data).token;

                this.authApi = authApi;

                callback(authApi);
              }
            );
          },
          onDataChanged: () => {
            if (this.isDev || this.isHomolog) {
              this.setContent();
            }
          },
          onTemplateLoaded: () => {
            this.isLoaded = true;

            this.hideStripoWatermark();
          },
        });
      };
      document.body.appendChild(script);
    },
    request(method, url, data, callback) {
      var req = new XMLHttpRequest();
      req.onreadystatechange = function () {
        if (req.readyState === 4 && req.status === 200) {
          callback(req.responseText);
        } else if (req.readyState === 4 && req.status !== 200) {
          console.error(
            "Can not complete request. Please check you entered a valid PLUGIN_ID and SECRET_KEY values"
          );
        }
      };
      req.open(method, url, true);
      if (method !== "GET") {
        req.setRequestHeader("content-type", "application/json");
      }
      req.send(data);
    },
    hideStripoWatermark() {
      const watermarktEl = document.querySelector(".sripo-watermark");

      if (watermarktEl) {
        watermarktEl.style.display = "none";
      }
    },
    stopPlugin() {
      window.StripoApi.stop();
    },
  },
};
